import ApiBase from './ApiBase';
import axios from 'axios';

class UserMailApi extends ApiBase {
  async create(emailData) {
    const headers = this.getHeaders();

    const request = {
      url: `${this.API_URL}/mail/sendmail`,
      method: 'POST',
      headers: headers,
      data: emailData
    };

    const response = await axios.request(request);
    return response.data;
  }
}
export default new UserMailApi();
